package dev.wyns.ventrova.ui.android

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.tween
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.gestures.detectVerticalDragGestures
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBars
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.windowInsetsBottomHeight
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Snackbar
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.material3.Typography
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import dev.wyns.ventrova.AppDependencies
import dev.wyns.ventrova.app.AppEnvironment
import dev.wyns.ventrova.app.AppUiState
import dev.wyns.ventrova.app.PlaceItem
import dev.wyns.ventrova.app.rememberAppEnvironment
import dev.wyns.ventrova.data.model.VeganLevel
import dev.wyns.ventrova.data.model.fryOilStatus
import dev.wyns.ventrova.platform.BackNavigation
import dev.wyns.ventrova.platform.LocalBackNavigation
import dev.wyns.ventrova.resources.Res
import dev.wyns.ventrova.resources.filter_all_levels
import dev.wyns.ventrova.resources.filter_clear_filters
import dev.wyns.ventrova.resources.filter_open_now
import dev.wyns.ventrova.resources.filter_up_to
import dev.wyns.ventrova.resources.filters
import dev.wyns.ventrova.resources.ic_add_location_alt
import dev.wyns.ventrova.resources.ic_check
import dev.wyns.ventrova.resources.ic_close
import dev.wyns.ventrova.resources.ic_eco_filled
import dev.wyns.ventrova.resources.ic_expand_less
import dev.wyns.ventrova.resources.ic_expand_more
import dev.wyns.ventrova.resources.ic_favorite
import dev.wyns.ventrova.resources.ic_favorite_filled
import dev.wyns.ventrova.resources.ic_map
import dev.wyns.ventrova.resources.ic_map_filled
import dev.wyns.ventrova.resources.ic_my_location
import dev.wyns.ventrova.resources.ic_person
import dev.wyns.ventrova.resources.ic_person_filled
import dev.wyns.ventrova.resources.ic_schedule
import dev.wyns.ventrova.resources.ic_search
import dev.wyns.ventrova.resources.ic_tune
import dev.wyns.ventrova.resources.loading
import dev.wyns.ventrova.resources.map_attribution
import dev.wyns.ventrova.resources.nearby_count
import dev.wyns.ventrova.resources.nearby_nothing_found
import dev.wyns.ventrova.resources.search_in_app
import dev.wyns.ventrova.resources.suggest_short
import dev.wyns.ventrova.resources.tab_favorites
import dev.wyns.ventrova.resources.tab_map
import dev.wyns.ventrova.resources.tab_profile
import dev.wyns.ventrova.resources.tab_search
import dev.wyns.ventrova.ui.components.FryOilLine
import dev.wyns.ventrova.ui.components.LevelGlyph
import dev.wyns.ventrova.ui.components.LevelTypeDistanceLine
import dev.wyns.ventrova.ui.components.OpenStatusLine
import dev.wyns.ventrova.ui.components.PlaceListSkeleton
import dev.wyns.ventrova.ui.components.PlaceRowSkeleton
import dev.wyns.ventrova.ui.components.PlaceThumbnail
import dev.wyns.ventrova.ui.components.SkeletonLine
import dev.wyns.ventrova.ui.components.VIcon
import dev.wyns.ventrova.ui.components.bodyStyle
import dev.wyns.ventrova.ui.components.filterSummary
import dev.wyns.ventrova.ui.map.MapDecorations
import dev.wyns.ventrova.ui.map.MarkerStyle
import dev.wyns.ventrova.ui.map.PlacesMap
import dev.wyns.ventrova.ui.theme.ProvideVentrovaFonts
import dev.wyns.ventrova.ui.theme.VentrovaColors
import dev.wyns.ventrova.ui.theme.displayStyle
import dev.wyns.ventrova.ui.theme.distanceLabel
import dev.wyns.ventrova.ui.theme.label
import dev.wyns.ventrova.ui.theme.loadMessageText
import dev.wyns.ventrova.ui.theme.palette
import dev.wyns.ventrova.ui.theme.shortLabel
import dev.wyns.ventrova.ui.theme.withFontFamily
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.pluralStringResource
import org.jetbrains.compose.resources.stringResource

internal enum class AndroidTab(val label: StringResource, val icon: DrawableResource, val selectedIcon: DrawableResource) {
    Map(Res.string.tab_map, Res.drawable.ic_map, Res.drawable.ic_map_filled),
    Search(Res.string.tab_search, Res.drawable.ic_search, Res.drawable.ic_search),
    Favorites(Res.string.tab_favorites, Res.drawable.ic_favorite, Res.drawable.ic_favorite_filled),
    Profile(Res.string.tab_profile, Res.drawable.ic_person, Res.drawable.ic_person_filled),
}

private enum class Detent { Peek, Half, Full }

private val NavBarHeight = 72.dp
private val AndroidColorScheme = lightColorScheme(
    primary = VentrovaColors.Accent,
    onPrimary = Color.White,
    primaryContainer = VentrovaColors.AccentContainer,
    onPrimaryContainer = VentrovaColors.OnAccentContainer,
    secondaryContainer = VentrovaColors.NavIndicator,
    onSecondaryContainer = VentrovaColors.OnAccentContainer,
    surface = VentrovaColors.Canvas,
    onSurface = VentrovaColors.Ink,
    onSurfaceVariant = VentrovaColors.Secondary,
    surfaceContainer = VentrovaColors.Sand,
    surfaceContainerLow = VentrovaColors.Canvas,
    surfaceContainerHigh = VentrovaColors.SandLight,
    outline = VentrovaColors.OutlineStrong,
    outlineVariant = VentrovaColors.Outline,
    background = VentrovaColors.Canvas,
    error = VentrovaColors.ErrorAndroid,
)

internal val AndroidDecorations = MapDecorations(
    markerStyle = MarkerStyle.Android,
    locationColor = VentrovaColors.LocationAndroid,
    radiusRingColor = VentrovaColors.Accent.copy(alpha = 0.5f),
    radiusRingFill = VentrovaColors.Accent.copy(alpha = 0.06f),
    radiusRingDashed = false,
)

/**
 * The Android (Material 3) layout of the design, used by the Android app and by the web app in
 * Android browsers. The system font is Roboto on Android; the web passes a bundled copy.
 */
@Composable
fun AndroidApp(
    dependencies: AppDependencies,
    backNavigation: BackNavigation,
    bodyFont: @Composable () -> FontFamily = { FontFamily.Default },
) {
    val body = bodyFont()
    MaterialTheme(colorScheme = AndroidColorScheme, typography = Typography().withFontFamily(body)) {
        ProvideVentrovaFonts(body = body) {
            CompositionLocalProvider(LocalBackNavigation provides backNavigation) {
                val env = rememberAppEnvironment(dependencies)
                val state by env.viewModel.state.collectAsStateWithLifecycle()
                AndroidScreen(env, state)
            }
        }
    }
}

@Composable
private fun AndroidScreen(env: AppEnvironment, state: AppUiState) {
    val viewModel = env.viewModel
    var tab by rememberSaveable { mutableStateOf(AndroidTab.Map) }
    var detent by rememberSaveable { mutableStateOf(Detent.Peek) }
    var filtersOpen by rememberSaveable { mutableStateOf(false) }
    var suggestOpen by rememberSaveable { mutableStateOf(false) }
    val snackbar = remember { SnackbarHostState() }

    LaunchedEffect(state.message) {
        val message = state.message ?: return@LaunchedEffect
        snackbar.showSnackbar(loadMessageText(message.kind))
        viewModel.consumeMessage(message)
    }

    val back = LocalBackNavigation.current
    back.BackHandler(enabled = state.detail == null && tab == AndroidTab.Map && state.selected != null) { viewModel.selectPlace(null) }
    back.BackHandler(enabled = state.detail == null && tab != AndroidTab.Map) { tab = AndroidTab.Map }
    back.BackHandler(enabled = state.detail != null) { viewModel.closeDetail() }
    back.BackHandler(enabled = filtersOpen) { filtersOpen = false }
    back.BackHandler(enabled = suggestOpen) {
        suggestOpen = false
        viewModel.resetSuggestion()
    }

    BoxWithConstraints(Modifier.fillMaxSize().background(VentrovaColors.MapBackground)) {
        val sheetHeight = when {
            state.selected != null -> 160.dp
            detent == Detent.Peek -> 84.dp
            detent == Detent.Half -> maxHeight * 0.48f
            else -> maxHeight - 170.dp
        }
        val animatedSheet by animateDpAsState(sheetHeight, tween(380))

        PlacesMap(
            controller = env.map,
            places = state.nearby,
            selectedId = state.selected?.id,
            decorations = AndroidDecorations,
            onMarkerClick = {
                viewModel.selectPlace(it.id)
                env.focus(it, fractionY = 0.38f)
            },
            onMapClick = { viewModel.selectPlace(null) },
            onViewportChanged = viewModel::onViewportChanged,
            userLocation = state.userLocation,
            radiusCenter = state.referencePoint,
            radiusKm = state.filters.radiusKm,
            modifier = Modifier.fillMaxSize(),
        )

        SearchBarAndChips(
            state = state,
            onSearch = { tab = AndroidTab.Search },
            onProfile = { tab = AndroidTab.Profile },
            onFilters = { filtersOpen = true },
            onToggleLevel = viewModel::toggleLevel,
            onToggleOpenNow = viewModel::toggleOpenNow,
        )

        Text(
            stringResource(Res.string.map_attribution),
            style = bodyStyle(8.5.sp, color = VentrovaColors.Ink.copy(alpha = 0.5f)),
            modifier = Modifier.align(Alignment.BottomEnd).navigationBarsPadding().padding(end = 12.dp, bottom = NavBarHeight + animatedSheet + 6.dp),
        )

        MapFabs(
            onLocate = env::locate,
            onSuggest = { suggestOpen = true },
            modifier = Modifier.align(Alignment.BottomEnd).navigationBarsPadding().padding(end = 16.dp, bottom = NavBarHeight + animatedSheet + 16.dp),
        )

        PlacesSheet(
            state = state,
            height = animatedSheet,
            listOpen = detent != Detent.Peek,
            detentIcon = if (detent == Detent.Full) Res.drawable.ic_expand_more else Res.drawable.ic_expand_less,
            onCycleDetent = { detent = Detent.entries[(detent.ordinal + 1) % Detent.entries.size] },
            onDrag = { up -> detent = if (up) Detent.entries[minOf(detent.ordinal + 1, 2)] else Detent.entries[maxOf(detent.ordinal - 1, 0)] },
            onOpen = { viewModel.openDetail(it.id) },
            onDeselect = { viewModel.selectPlace(null) },
            onClearFilters = viewModel::clearFilters,
            modifier = Modifier.align(Alignment.BottomCenter),
        )

        when (tab) {
            AndroidTab.Map -> Unit
            AndroidTab.Search -> AndroidSearchPage(state, viewModel, onBack = { tab = AndroidTab.Map }, onSuggest = { suggestOpen = true })
            AndroidTab.Favorites -> AndroidFavoritesPage(state, viewModel)
            AndroidTab.Profile -> AndroidProfilePage(onSuggest = { suggestOpen = true }, onNotAvailable = { viewModel.showMessage(dev.wyns.ventrova.app.AppMessage.Kind.NotAvailableYet) })
        }

        AndroidNavigationBar(
            selected = tab,
            onSelect = {
                tab = it
                viewModel.selectPlace(null)
            },
            modifier = Modifier.align(Alignment.BottomCenter),
        )

        AnimatedVisibility(
            visible = state.detail != null,
            enter = fadeIn(tween(250)) + slideInVertically(tween(380)) { it / 20 },
            exit = fadeOut(tween(200)) + slideOutVertically(tween(300)) { it / 20 },
        ) {
            state.detail?.let { AndroidDetail(it, state.detailMenu, env) }
        }

        if (filtersOpen) {
            AndroidFilterSheet(state, viewModel, onDismiss = { filtersOpen = false })
        }
        if (suggestOpen) {
            AndroidSuggestDialog(state.suggestion, viewModel, onDismiss = {
                suggestOpen = false
                viewModel.resetSuggestion()
            })
        }
        if (state.showOnboarding) {
            AndroidOnboarding(env)
        }

        SnackbarHost(
            snackbar,
            modifier = Modifier.align(Alignment.BottomCenter).navigationBarsPadding().padding(start = 12.dp, end = 12.dp, bottom = NavBarHeight + 12.dp),
        ) { data ->
            Snackbar(
                snackbarData = data,
                shape = RoundedCornerShape(8.dp),
                containerColor = Color(0xFF30332E),
                contentColor = VentrovaColors.SandLight,
            )
        }
    }
}

@Composable
private fun SearchBarAndChips(
    state: AppUiState,
    onSearch: () -> Unit,
    onProfile: () -> Unit,
    onFilters: () -> Unit,
    onToggleLevel: (VeganLevel) -> Unit,
    onToggleOpenNow: () -> Unit,
) {
    Column(Modifier.fillMaxWidth().statusBarsPadding().padding(top = 8.dp)) {
        Row(
            Modifier
                .padding(horizontal = 16.dp)
                .fillMaxWidth()
                .height(56.dp)
                .shadow(2.dp, RoundedCornerShape(28.dp))
                .background(VentrovaColors.SandLight, RoundedCornerShape(28.dp))
                .clickable(onClick = onSearch)
                .padding(start = 16.dp, end = 6.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(12.dp),
        ) {
            VIcon(Res.drawable.ic_eco_filled, tint = VentrovaColors.Accent)
            Text(stringResource(Res.string.search_in_app), style = bodyStyle(16.sp, color = VentrovaColors.Secondary), modifier = Modifier.weight(1f))
            Box(
                Modifier.size(36.dp).clip(CircleShape).background(VentrovaColors.AccentContainer).clickable(onClick = onProfile),
                contentAlignment = Alignment.Center,
            ) {
                VIcon(Res.drawable.ic_person_filled, size = 20.dp, tint = VentrovaColors.OnAccentContainerAlt)
            }
        }
        Row(
            Modifier.padding(top = 10.dp).horizontalScroll(rememberScrollState()).padding(horizontal = 16.dp, vertical = 2.dp),
            horizontalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            val sheetFilters = state.filters.sheetOnlyCount
            FilterChipBox(active = sheetFilters > 0, onClick = onFilters) {
                VIcon(Res.drawable.ic_tune, size = 18.dp)
                Text(stringResource(Res.string.filters), style = chipText())
                if (sheetFilters > 0) {
                    Box(Modifier.size(18.dp).background(VentrovaColors.Accent, CircleShape), contentAlignment = Alignment.Center) {
                        Text("$sheetFilters", style = bodyStyle(11.sp, FontWeight.Bold, Color.White))
                    }
                }
            }
            VeganLevel.entries.forEach { level ->
                val active = level in state.filters.levels
                val palette = level.palette
                FilterChipBox(
                    active = active,
                    onClick = { onToggleLevel(level) },
                    activeBackground = palette.soft,
                    activeBorder = palette.color,
                    activeContent = palette.ink,
                ) {
                    if (active) VIcon(Res.drawable.ic_check, size = 18.dp) else LevelGlyph(level, size = 12.dp)
                    Text(stringResource(level.shortLabel), style = chipText())
                }
            }
            FilterChipBox(active = state.filters.openNow, onClick = onToggleOpenNow) {
                VIcon(if (state.filters.openNow) Res.drawable.ic_check else Res.drawable.ic_schedule, size = 18.dp)
                Text(stringResource(Res.string.filter_open_now), style = chipText())
            }
        }
    }
}

@Composable
private fun chipText() = bodyStyle(14.sp, FontWeight.Medium, androidx.compose.material3.LocalContentColor.current)

/** Material 3 filter chip in the design's colors (10dp corners, outlined when inactive). */
@Composable
internal fun FilterChipBox(
    active: Boolean,
    onClick: () -> Unit,
    activeBackground: Color = VentrovaColors.NavIndicator,
    activeBorder: Color = VentrovaColors.Accent,
    activeContent: Color = VentrovaColors.Ink,
    inactiveBackground: Color = VentrovaColors.Canvas,
    elevated: Boolean = true,
    content: @Composable () -> Unit,
) {
    val shape = RoundedCornerShape(10.dp)
    Surface(
        onClick = onClick,
        shape = shape,
        color = if (active) activeBackground else inactiveBackground,
        contentColor = if (active) activeContent else VentrovaColors.Ink,
        shadowElevation = if (elevated) 1.dp else 0.dp,
        modifier = Modifier.height(34.dp).border(1.dp, if (active) activeBorder else VentrovaColors.Outline, shape),
    ) {
        Row(
            Modifier.padding(start = 9.dp, end = 14.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(6.dp),
        ) { content() }
    }
}

@Composable
private fun MapFabs(onLocate: () -> Unit, onSuggest: () -> Unit, modifier: Modifier) {
    Column(modifier, horizontalAlignment = Alignment.End, verticalArrangement = Arrangement.spacedBy(12.dp)) {
        Surface(
            onClick = onLocate,
            shape = RoundedCornerShape(14.dp),
            color = VentrovaColors.SandLight,
            contentColor = VentrovaColors.LocationAndroid,
            shadowElevation = 3.dp,
            modifier = Modifier.size(48.dp),
        ) {
            Box(contentAlignment = Alignment.Center) { VIcon(Res.drawable.ic_my_location) }
        }
        Surface(
            onClick = onSuggest,
            shape = RoundedCornerShape(18.dp),
            color = VentrovaColors.AccentContainer,
            contentColor = VentrovaColors.OnAccentContainer,
            shadowElevation = 3.dp,
            modifier = Modifier.height(56.dp),
        ) {
            Row(Modifier.padding(start = 16.dp, end = 20.dp), verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(10.dp)) {
                VIcon(Res.drawable.ic_add_location_alt)
                Text(stringResource(Res.string.suggest_short), style = bodyStyle(15.sp, FontWeight.SemiBold, VentrovaColors.OnAccentContainer))
            }
        }
    }
}

@Composable
private fun PlacesSheet(
    state: AppUiState,
    height: Dp,
    listOpen: Boolean,
    detentIcon: DrawableResource,
    onCycleDetent: () -> Unit,
    onDrag: (up: Boolean) -> Unit,
    onOpen: (PlaceItem) -> Unit,
    onDeselect: () -> Unit,
    onClearFilters: () -> Unit,
    modifier: Modifier,
) {
    Column(
        modifier
            .fillMaxWidth()
            .shadow(10.dp, RoundedCornerShape(topStart = 28.dp, topEnd = 28.dp))
            .background(VentrovaColors.Canvas, RoundedCornerShape(topStart = 28.dp, topEnd = 28.dp))
            .navigationBarsPadding()
            .padding(bottom = NavBarHeight)
            .height(height),
    ) {
        val selected = state.selected
        if (selected != null) {
            SheetHandle(Modifier.padding(top = 10.dp))
            SelectedPlaceCard(selected, onOpen = { onOpen(selected) }, onClose = onDeselect)
            return@Column
        }
        var dragTotal by remember { mutableStateOf(0f) }
        Column(
            Modifier
                .fillMaxWidth()
                .clickable(onClick = onCycleDetent)
                .pointerInput(Unit) {
                    detectVerticalDragGestures(
                        onDragStart = { dragTotal = 0f },
                        onDragEnd = { if (kotlin.math.abs(dragTotal) > 24) onDrag(dragTotal < 0) },
                        onVerticalDrag = { _, amount -> dragTotal += amount },
                    )
                }
                .padding(start = 20.dp, end = 20.dp, top = 10.dp, bottom = 12.dp),
        ) {
            SheetHandle(Modifier.padding(bottom = 12.dp))
            Row(verticalAlignment = Alignment.CenterVertically) {
                Column(Modifier.weight(1f)) {
                    if (state.isLoading) {
                        SkeletonLine(width = 170.dp, height = 18.dp, modifier = Modifier.padding(vertical = 2.dp))
                        SkeletonLine(width = 110.dp, height = 12.dp, modifier = Modifier.padding(top = 5.dp))
                    } else {
                        Text(pluralStringResource(Res.plurals.nearby_count, state.nearby.size, state.nearby.size), style = bodyStyle(18.sp, FontWeight.SemiBold))
                        Text(filterSummary(state.filters), style = bodyStyle(13.5.sp, color = VentrovaColors.Secondary), maxLines = 1, overflow = TextOverflow.Ellipsis)
                    }
                }
                VIcon(detentIcon, tint = VentrovaColors.Secondary)
            }
        }
        if (listOpen) {
            HorizontalDivider(color = Color(0xFFE6E3DB))
            if (state.isLoading) {
                PlaceListSkeleton(count = 6, loadingLabel = stringResource(Res.string.loading)) { index -> AndroidRowSkeleton(index) }
            } else if (state.nearby.isEmpty()) {
                Row(Modifier.fillMaxWidth().padding(40.dp), horizontalArrangement = Arrangement.Center) {
                    Text(stringResource(Res.string.nearby_nothing_found) + " ", style = bodyStyle(14.sp, color = VentrovaColors.Secondary))
                    Text(
                        stringResource(Res.string.filter_clear_filters),
                        style = bodyStyle(14.sp, FontWeight.SemiBold, VentrovaColors.Accent),
                        modifier = Modifier.clickable(onClick = onClearFilters),
                    )
                }
            }
            LazyColumn(contentPadding = PaddingValues(bottom = 12.dp)) {
                items(state.nearby, key = { it.id }) { item ->
                    AndroidPlaceRow(item, onClick = { onOpen(item) })
                }
            }
        }
    }
}

@Composable
internal fun AndroidPlaceRow(item: PlaceItem, onClick: () -> Unit, trailing: (@Composable () -> Unit)? = null) {
    Row(
        Modifier.fillMaxWidth().clickable(onClick = onClick).padding(horizontal = 20.dp, vertical = 10.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(16.dp),
    ) {
        PlaceThumbnail(item.place, Modifier.size(56.dp), RoundedCornerShape(16.dp))
        Column(Modifier.weight(1f)) {
            Text(item.place.name, style = bodyStyle(16.sp, FontWeight.SemiBold), maxLines = 1, overflow = TextOverflow.Ellipsis)
            LevelTypeDistanceLine(item, Modifier.padding(top = 2.dp), style = bodyStyle(13.5.sp, color = VentrovaColors.Secondary))
            FryOilLine(item.place, Modifier.padding(top = 2.dp), fontSize = 13.sp, iconSize = 15.dp)
            OpenStatusLine(item, Modifier.padding(top = 2.dp), style = bodyStyle(13.5.sp, color = VentrovaColors.Secondary))
        }
        trailing?.invoke()
    }
}

/** Material placeholder for [AndroidPlaceRow]. */
@Composable
internal fun AndroidRowSkeleton(index: Int, thumbSize: Dp = 56.dp, lines: Int = 2) {
    PlaceRowSkeleton(
        Modifier.padding(horizontal = 20.dp, vertical = 10.dp),
        thumbSize = thumbSize,
        thumbShape = RoundedCornerShape(16.dp),
        spacing = 16.dp,
        lines = lines,
        seed = index,
    )
}

@Composable
private fun SelectedPlaceCard(item: PlaceItem, onOpen: () -> Unit, onClose: () -> Unit) {
    Box(Modifier.fillMaxWidth().clickable(onClick = onOpen).padding(start = 20.dp, end = 20.dp, top = 12.dp, bottom = 16.dp)) {
        Row(horizontalArrangement = Arrangement.spacedBy(16.dp)) {
            PlaceThumbnail(item.place, Modifier.size(112.dp), RoundedCornerShape(24.dp), iconSize = 32.dp)
            Column(Modifier.weight(1f)) {
                // The sheet has a fixed height, so the fry oil line takes the name's second line.
                val nameLines = if (item.place.fryOilStatus != null) 1 else 2
                Text(item.place.name, style = displayStyle(21), modifier = Modifier.padding(end = 30.dp), maxLines = nameLines, overflow = TextOverflow.Ellipsis)
                dev.wyns.ventrova.ui.components.LevelBadge(
                    item.place.veganLevel,
                    Modifier.padding(top = 8.dp).height(28.dp),
                    shape = RoundedCornerShape(8.dp),
                    fontSize = 13.sp,
                    contentPadding = PaddingValues(start = 8.dp, end = 10.dp),
                )
                FryOilLine(item.place, Modifier.padding(top = 2.dp), fontSize = 13.sp, iconSize = 15.dp)
                OpenStatusLine(
                    item,
                    Modifier.padding(top = 6.dp),
                    style = bodyStyle(13.5.sp, color = VentrovaColors.Secondary),
                    suffix = item.distanceMeters?.let { distanceLabel(it) },
                )
            }
        }
        Box(
            Modifier.align(Alignment.TopEnd).offset(x = 6.dp, y = (-2).dp).size(36.dp).clip(CircleShape).clickable(onClick = onClose),
            contentAlignment = Alignment.Center,
        ) {
            VIcon(Res.drawable.ic_close, size = 22.dp, tint = VentrovaColors.Secondary)
        }
    }
}

@Composable
private fun SheetHandle(modifier: Modifier = Modifier) {
    Box(Modifier.fillMaxWidth().then(modifier), contentAlignment = Alignment.Center) {
        Box(Modifier.width(32.dp).height(4.dp).background(VentrovaColors.Outline, RoundedCornerShape(2.dp)))
    }
}

@Composable
private fun AndroidNavigationBar(selected: AndroidTab, onSelect: (AndroidTab) -> Unit, modifier: Modifier) {
    Column(modifier.fillMaxWidth().background(VentrovaColors.Sand)) {
        Row(Modifier.fillMaxWidth().height(NavBarHeight).padding(top = 6.dp)) {
            AndroidTab.entries.forEach { tab ->
                val active = tab == selected
                val color = if (active) VentrovaColors.OnAccentContainer else VentrovaColors.Secondary
                Column(
                    Modifier.weight(1f).clickable(
                        interactionSource = remember { androidx.compose.foundation.interaction.MutableInteractionSource() },
                        indication = null,
                    ) { onSelect(tab) },
                    horizontalAlignment = Alignment.CenterHorizontally,
                    verticalArrangement = Arrangement.spacedBy(4.dp),
                ) {
                    Box(
                        Modifier.width(56.dp).height(32.dp).background(if (active) VentrovaColors.NavIndicator else Color.Transparent, RoundedCornerShape(16.dp)),
                        contentAlignment = Alignment.Center,
                    ) {
                        VIcon(if (active) tab.selectedIcon else tab.icon, tint = color)
                    }
                    Text(stringResource(tab.label), style = bodyStyle(12.sp, if (active) FontWeight.Bold else FontWeight.Medium, color))
                }
            }
        }
        Spacer(Modifier.windowInsetsBottomHeight(WindowInsets.navigationBars))
    }
}
